import { render, staticRenderFns } from "./PemutakhiranPerubahanKkprl.vue?vue&type=template&id=37244870&"
import script from "./PemutakhiranPerubahanKkprl.vue?vue&type=script&lang=js&"
export * from "./PemutakhiranPerubahanKkprl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports